import { strlen } from 'fbjs/lib/UnicodeUtils'
import { Block, Text, Inline } from 'slate'
import EntityTypes from '@slite/editor/lib/types/EntityTypes'

export default function getEntitiesRange(value) {
  const entities = []
  let offset = 0

  function serializeNode(node) {
    if (Block.isBlock(node)) {
      node.nodes.forEach(serializeNode)
      offset += 1
    } else if (Inline.isInline(node)) {
      if ([EntityTypes.MENTION, EntityTypes.NOTELINK].includes(node.type)) {
        entities.push({
          type: node.type,
          data: node.data.toJS(),
          startOffset: offset,
          endOffset: offset + strlen(node.text) - 1,
        })
      }
      offset += strlen(node.text)
    } else if (Text.isText(node)) {
      offset += strlen(node.text)
    }
  }

  value.document.nodes.forEach(serializeNode)

  return entities
}
